// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const archaludon: PokeData = {
  "id": 1018,
  "name": "archaludon",
  "height": 20,
  "weight": 600,
  "base_experience": 300,
  "types": [
    PokeType.STEEL,
    PokeType.DRAGON
  ],
  "api_moves": [
    "leer",
    "hyper-beam",
    "focus-energy",
    "metal-claw",
    "rock-smash",
    "metal-sound",
    "iron-defense",
    "dragon-claw",
    "metal-burst",
    "flash-cannon",
    "hone-claws",
    "dragon-tail",
    "breaking-swipe",
    "electro-shot"
  ],
  "moves": [
    "leer",
    "metal-claw",
    "rock-smash",
    "metal-sound",
    "dragon-claw",
    "metal-burst",
    "dragon-breath",
    "gear-up",
    "dragon-vortex",
    "draco-meteor",
    "dragon-fang",
    "iron-defense",
    "metal-rush"
  ],
  "evolution_chain": {
    "id": 465,
    "item": null,
    "species": [
      {
        "name": "duraludon",
        "order": 884,
        "types": [
          PokeType.STEEL,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "archaludon",
        "order": 1020,
        "types": [
          PokeType.STEEL,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 884,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 123,
    "speed": 112,
    "ability_power": 165
  },
  "stat_changes": [],
  "catch_rate": 10,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
